import React from 'react'

const HomeMission = () => {
  return (
    <>

      <section className="working-process-section-3 section-space fix" style={{ marginTop: "-30px" }}>
        <div className="shape-1">
          <img src="assets/images/home-3/shape-1.png" alt="img" />
        </div>
        <div className="shape-2">
          <img src="assets/images/home-3/shape-2.png" alt="img" />
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-8 col-xxl-7">
              <div className="section-content-block text-center">
                <span className="section-tag wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Welcome to Rahul Logistics Katni</span>
                <h2 className="section-title is-text-dark">
                  <div style={{ position: 'relative', display: 'inline-block' }}>
                    Our Mission & Vision
                  </div>
                </h2>
                <p className="section-text col-lg-10 mx-auto wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp' }}>To be the most trusted and innovative logistics partner for businesses in India and across the globe. Delivering Excellence, Every Mile of the Way.</p>
              </div>
            </div>
          </div>
          <div className="row gy-4 mt-4 justify-content-between align-items-center">
            <div className="col-xl-11 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="working-process-box-items-3">
                <div className="working-process-icon-box">
                  <div className="icon">
                    <img src="assets/images/home-3/icon/01.svg" alt="img" />
                  </div>
                  <h4>Our Mission & Vision</h4>
                </div>
                <p>At Rahul Logistics, our mission is to attract and retain customers by providing Best in Class transportation solutions and fostering a profitable, disciplined culture of safety, service and trust through innovation and advanced technology. Safety, Winning Attitude, Teamwork, Balance, Ethics, Communication, Change, Accountability, Respect & Charity, Development, Trust.</p>
              </div>
            </div>
            <div className="col-xl-1 d-none d-xl-block wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
              <div className="arrow-shape-1">
                <img src="assets/images/home-3/progress-shape.png" alt="img" />
              </div>
            </div>
            {/* <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".6s" style={{ visibility: 'visible', animationDelay: '0.6s', animationName: 'fadeInUp' }}>
              <div className="working-process-box-items-3">
                <div className="working-process-icon-box">
                  <div className="icon">
                    <img src="assets/images/home-3/icon/02.svg" alt="img" />
                  </div>
                  <h4>Our Vision</h4>
                </div>
                <p>Our recent projects highlight our expertise in delivering tailored for solutions that meet the unique and the needs and objectives</p>
              </div>
            </div> */}


          </div>
        </div>
      </section>


    </>
  )
}

export default HomeMission